import { createClient } from '@supabase/supabase-js';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { ChannelContext } from '../../context';
import { supabaseApi } from '../../services';

const SUPABASE_URL = 'https://cmktqhvqtavojwpcouqh.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_bZPrR_Dgh1LHi8TYgAhK1g_4ijzJSx-';

export const useSupabase = () => {
  const { id: channelId } = useContext(ChannelContext).channel;

  const [supabaseGenerateToken] = supabaseApi.endpoints.supabaseGenerateToken.useMutation();

  const [token, setToken] = useState<string | null>(null);

  const [loading, setLoading] = useState(true);

  const getSupabaseToken = useCallback(async () => {
    try {
      setLoading(true);

      const { token } = await supabaseGenerateToken({ channelId }).unwrap();

      if (!token) {
        return;
      }

      setToken(token);
    } catch (_) {
      setToken(null);
    } finally {
      setLoading(false);
    }
  }, [channelId, supabaseGenerateToken]);

  useEffect(() => {
    getSupabaseToken();
  }, [getSupabaseToken]);

  const supabase = useMemo(() => {
    if (!token) {
      return null;
    }

    return createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
      global: {
        headers: { Authorization: `Bearer ${token}` },
      },
    });
  }, [token]);

  return { supabase, loading };
};
